import { render, staticRenderFns } from "./finishedOrders.vue?vue&type=template&id=27ce05bd&"
import script from "./finishedOrders.vue?vue&type=script&lang=js&"
export * from "./finishedOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports